// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpMenuItem } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const MenuItem = wrap(jpMenuItem(), { events: { onExpand: 'expanded-change' } });
// @ts-expect-error unknown property
MenuItem.displayName = 'Jupyter.MenuItem';
